
const CircledImage = ({ source }) => {
    return (
        <div style={styles.mainContainer}>
            <img src={source} style={styles.image} />
        </div>
    );
};

export default CircledImage;

const styles = {
    mainContainer: {
        borderRadius: "50%",
        border: "solid 1px #FFFFFF",
        width: 40,
        height: 40,
        overflow: 'hidden'
    },
    image: {
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        objectFit: 'cover'
    }
}